module.exports = __webpack_public_path__ + "media/8an-bull.9f787eed.mp3";